export const START_TRANS = 'START_TRANS';
export const END_TRANS = 'END_TRANS';
export const SET_STAGE = 'SET_STAGE';
export const SET_SCANNING_GENERATOR = 'SET_SCANNING_GENERATOR'